export default __webpack_public_path__ + "static/media/default-product.b075c35a.jpg";